import { render, staticRenderFns } from "./DJSX.vue?vue&type=template&id=3fb3ee30&scoped=true"
import script from "./DJSX.vue?vue&type=script&lang=js"
export * from "./DJSX.vue?vue&type=script&lang=js"
import style0 from "./DJSX.vue?vue&type=style&index=0&id=3fb3ee30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb3ee30",
  null
  
)

export default component.exports